{
  "ascending": "ascendente",
  "ascendingSort": "Ordenar por coluna {columnName} em ordem ascendente",
  "collapse": "Colapsar",
  "columnSize": "{value} pixels",
  "descending": "descendente",
  "descendingSort": "Ordenar por coluna {columnName} em ordem descendente",
  "expand": "Expandir",
  "resizerDescription": "Prima Enter para iniciar o redimensionamento",
  "select": "Selecionar",
  "selectAll": "Selecionar tudo",
  "sortable": "Coluna ordenável"
}
